/**
 * What flag a raid draws, by the KIND of island being hit.
 *
 * Reputation in Corsalia is emergent: nobody picks a faction, the acts decide.
 * That only works if the player can see, at the moment of choosing, which way an
 * act pushes them. The raid launcher previewed the loot and the losses but never
 * the allegiance, so the single most identity-defining button in the game was
 * also its most opaque one.
 *
 * Mirrors the backend rule (ReputationRules::forRaid): storming a pirate lair
 * serves the crown (loyal + warrior), sacking any lawful possession is piracy
 * (outlaw + warrior). Only the DIRECTION is stated here, never a magnitude: the
 * numbers live in the domain and must not be duplicated into the front.
 *
 * Returns null for anything that carries no alignment, so the caller can simply
 * omit the line rather than render an empty one.
 */
export function raidFlagHint(islandType: string): string | null {
  if (islandType === 'pirate_lair') {
    return 'Ce raid te pousse vers le pavillon Marine : légal, guerrier.'
  }
  if (
    islandType === 'merchant_outpost'
    || islandType === 'production'
    || islandType === 'marine_port'
  ) {
    return 'Ce raid te pousse vers le pavillon Pirate : hors-la-loi, guerrier.'
  }
  return null
}
